import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import Button from '../../Common/Button/Button';

/**
 * Table Row Actions Component
 * Renders edit and delete buttons for table rows
 */
const TableActions = ({ 
  onEdit, 
  onDelete, 
  canEdit = true, 
  canDelete = true,
  disabled = false 
}) => {
  return (
    <div className="table-row-actions">
      {canEdit && (
        <Button
          variant="action"
          icon={faEdit}
          onClick={onEdit}
          disabled={disabled}
          size="small"
          title="Edit row"
        />
      )}
      
      {canDelete && (
        <Button
          variant="action"
          icon={faTrash}
          onClick={(event) => {
            event?.stopPropagation?.();
            onDelete(event);
          }}
          disabled={disabled}
          size="small"
          title="Delete row"
        />
      )}
    </div>
  );
};

export default TableActions;
